import { FC, useState } from 'react';
import { useStyles } from './styles';
import { DepartmentActionDialogProps } from './types';
import { Button, Grid, Paper, Modal, Checkbox, FormGroup, FormControlLabel, TextField } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
//import { useStore } from 'hooks/useRootStore';

export const DepartmentAction: FC<DepartmentActionDialogProps> = observer(
  ({
    label,
    buttonLabel,
    openModal,
    action,
    handleClose,
    notify,
    notifyStatus,
    status,
    appnotify,
    appnotifyStatus,
    reSyncProvider,
  }) => {
    const classes = useStyles();
    const [inputValue, setInputValue] = useState('');
    const handelAction = () => {
      if (action) {
        action();
      }
      setInputValue('');
      handleClose();
    };
    const Close = () => {
      setInputValue('');
      handleClose();
    };
    return (
      <Modal className={classes.modal} disablePortal disableEnforceFocus open={openModal} onEscapeKeyDown={handleClose}>
        <Paper className={classes.paper} elevation={3}>
          <p className={classes.title}>{label}</p>
          {notify !== undefined && (
            <div>
              <FormGroup row>
                <FormControlLabel
                  className={classes.notify}
                  control={
                    <Checkbox
                      checked={notify}
                      onChange={(event) => notifyStatus?.(event.target.checked)}
                      name='notfiy'
                      defaultChecked={false}
                    />
                  }
                  label='Notify End User via Email'
                />
              </FormGroup>
            </div>
          )}
          {appnotify !== undefined && reSyncProvider && reSyncProvider.length > 0 && (
            <>
              <FormGroup>
                <FormControlLabel
                  className={classes.notify}
                  control={
                    <Checkbox
                      checked={appnotify}
                      onChange={(event) => appnotifyStatus?.(event.target.checked)}
                      name='appStatus'
                      defaultChecked={false}
                    />
                  }
                  label='Do you want to delete on third party app ?'
                />
              </FormGroup>
            </>
          )}
          <Grid className={classes.marginTop} container>
            <TextField
              id='outlined-basic'
              value={inputValue}
              className={classes.inputText}
              onChange={(e) => setInputValue(e.target.value)}
              variant='outlined'
            />
          </Grid>
          <Grid className={classes.marginTop} container justify='space-between'>
            <Button className={classes.cancelButton} variant='contained' color='secondary' onClick={Close}>
              Cancel
            </Button>
            {inputValue === status ? (
              <Button className={classes.actionBtn} variant='contained' color='primary' onClick={handelAction}>
                {buttonLabel}
              </Button>
            ) : null}
          </Grid>
        </Paper>
      </Modal>
    );
  }
);
